import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-list-group',
  templateUrl: './list-group.component.html',
  styleUrl: './list-group.component.scss',
})
export class ListGroupComponent {
  //Flush value: list-group-flush
  @Input() flush: string;

  //Status Value; active, disabled
  @Input() status: string;

  @Input() listItems: any[];

  @Input() itemLabel: string;

  @Input() isActive: (item: any) => boolean = () => false;

  @Input() isDisabled: (item: any) => boolean = () => false;

  @Input() getColor: (item: any) => string = () => 'primary';

  @Input() itemBadge: string;

  //Size Value; xs,sm, md, lg,xl
  @Input() badgeSize: string = 'md';

  //Type Value; badge, circle, rounded, pill, outline-primary, badge-outline-secondary, badge-outline-success, badge-outline-danger, badge-outline-warning, badge-outline-info, badge-outline-light, badge-outline-dark
  @Input() badgeType: string = 'badge';

  //Color Value; primary, secondary, success, danger, warning, info, light, dark
  @Input() badgeColor: string = 'primary';

  //Light Value: Light
  @Input() badgeLight: string = '';

  @Input() isButton: boolean = false;

  @Input() itemHeader: string;

  @Input() itemContent: string;

  @Input() itemSum: string;

  @Input() itemDate: string;

  // groupHeaderStyle Value; text-primary, text-secondary, text-success, text-danger, text-warning, text-info, text-light, text-dark / bg-primary, bg-secondary, bg-success, bg-danger, bg-warning, bg-info, bg-light, bg-dark
  @Input() listItemStyle: string;

  @Output() listItemClickedEvent = new EventEmitter<any>();

  itemClicked(item: any): void {
    this.listItemClickedEvent.emit(item);
  }
}
